import { Base } from 'layouts'
import { IndustryGroupList } from 'components'

import * as S from './styled'

export function IndustryGroup() {
  return (
    <Base>
      <S.GridContainer container>
        <IndustryGroupList />
      </S.GridContainer>
    </Base>
  )
}
